<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="copyright">
        <a href="mailto://info@nodgames.com">
              Contact : info@nodgames.com
        </a>
        <br>
        &copy; {{ year }} NOD Games. All Rights Reserved.
        <br>
        <a href="/doc/Privacy Policy.pdf" style="margin: 5px;" target="_blank">Privacy Policy</a><a href="/doc/Terms and Conditions.pdf" style="margin: 5px;" target="_blank">Terms of use</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
